<script setup lang="ts">
import { twMerge } from "tailwind-merge"

const props = defineProps<{ class?: string }>()
</script>

<template>
  <h1
    :class="twMerge('text-lg leading-6 font-bold text-zinc-800', props.class)"
  >
    <slot />
  </h1>
</template>
